import { render, staticRenderFns } from "./CardChart.vue?vue&type=template&id=523d428d&scoped=true&"
import script from "./CardChart.vue?vue&type=script&lang=js&"
export * from "./CardChart.vue?vue&type=script&lang=js&"
import style0 from "./CardChart.vue?vue&type=style&index=0&id=523d428d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d428d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
